var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFinalizar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_90",
    "data-name": "Rect\\xE1ngulo 90",
    width: 20.714,
    height: 20.748,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Finalizar"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Finalizar",
    clipPath: "url(#clip-Finalizar)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_237",
    "data-name": "Grupo 237",
    transform: "translate(4.643 4.626)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_125",
    "data-name": "Trazado 125",
    d: "M9.977,17.765a2.184,2.184,0,0,1-.983,2.644A2.053,2.053,0,0,1,6.586,20.3a2.163,2.163,0,0,1-.827-2.487,6.735,6.735,0,0,1-.995-.328,2.2,2.2,0,0,1-.6-3.456c.262-.282.549-.54.809-.824a.383.383,0,0,0,.082-.3Q3.808,7.526,2.547,2.147a.75.75,0,0,0-.831-.665c-.316,0-.631,0-.947,0A.743.743,0,0,1,0,.731.734.734,0,0,1,.767.005,9.1,9.1,0,0,1,2.149.047a2.09,2.09,0,0,1,1.776,1.6c.175.613.31,1.238.464,1.857.015.059.033.118.054.192H6.075c-.513,2.811.309,5.086,2.778,6.566a5.5,5.5,0,0,0,6.256-.186A5.806,5.806,0,0,0,17.58,3.7h1.093c.416,0,.832,0,1.248,0a.74.74,0,0,1,.756,1.01q-.483,1.9-.97,3.8-.474,1.855-.947,3.71a2.236,2.236,0,0,1-2.349,1.833q-4.978,0-9.957,0a.49.49,0,0,0-.4.163c-.224.244-.461.476-.7.7a.756.756,0,0,0-.248.891.781.781,0,0,0,.823.466q6.2-.006,12.405,0a1.528,1.528,0,0,1,.3.016.737.737,0,0,1-.145,1.461c-.531.007-1.061,0-1.612,0a2.2,2.2,0,0,1-1.07,2.707,2.051,2.051,0,0,1-2.33-.157,2.2,2.2,0,0,1-.813-2.536Zm5.547.726a.738.738,0,1,0-.732.739.742.742,0,0,0,.732-.739M7.16,18.5a.737.737,0,0,0,.736.733.738.738,0,1,0-.012-1.477.737.737,0,0,0-.724.744",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_126",
    "data-name": "Trazado 126",
    d: "M124.454,20.942a4.437,4.437,0,1,1,4.435-4.438,4.442,4.442,0,0,1-4.435,4.438m-.751-4.011c-.327-.329-.64-.657-.968-.969A.737.737,0,0,0,121.687,17q.753.781,1.533,1.535a.694.694,0,0,0,.983,0q1.325-1.3,2.628-2.628a.676.676,0,0,0,.13-.773.7.7,0,0,0-.617-.453.765.765,0,0,0-.638.26c-.658.658-1.32,1.312-2,1.99",
    transform: "translate(-112.625 -11.325)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalizar);
export default __webpack_public_path__ + "static/media/Finalizar.2c9f10e7a62c930729433456159cebeb.svg";
export { ForwardRef as ReactComponent };